import { Components, Theme } from '@mui/material';

const MuiPaper: Components<Theme>['MuiPaper'] = {
  styleOverrides: {
    root: {
      boxShadow: 'none',
    },
  },
};

export default MuiPaper;
